import { observer } from 'mobx-react';
import * as React from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { MediaChooserContext, useMediaChooserContextController } from '../../../../web/components/MediaChooser/context';
import { EditIndustryHtmlNewsletterTemplate } from '../../../containers/templates/EditIndustryHtmlNewsletterTemplate';
import { AdminPrivateRoute } from '../../AdminPrivateRoute';
import { EditBlogPostTemplate } from '../EditBlogPostTemplate';
import { EditEmailTemplate } from '../EditEmailTemplate';
import { HwcCreateTemplate, HwcEditTemplate } from '../EditHandwrittenCardTemplate';
import { EditSocialTemplate } from '../EditSocialTemplate';
import { ViewHandwrittenCardTemplate } from '../ViewHandwrittenCardTemplate';
import { EditCampaignTemplateContext, IEditCampaignTemplateContext } from './context';
import { TitleDisplayName } from './presentation';

export interface IEditCampaignTemplateComponent {
	DisplayName: React.FC<{ readonly?: boolean; titleText: string }>;
}

export const EditCampaignTemplate: React.FC & Partial<IEditCampaignTemplateComponent> = observer(() => {
	const { path: matchPath } = useRouteMatch();
	const userSession = useUserSession();
	const mediaContext = useMediaChooserContextController();
	const [displayName, setDisplayName] = React.useState<string>('');
	const [context, setContext] = React.useState<IEditCampaignTemplateContext>({
		displayName,
		setDisplayName,
	});
	React.useEffect(() => {
		setContext(c => {
			return {
				...(c || {}),
				displayName,
			};
		});
	}, [displayName]);
	return (
		<EditCampaignTemplateContext.Provider value={context}>
			<Switch>
				<AdminPrivateRoute path={`${matchPath}/html-newsletter/edit`} userSession={userSession}>
					<EditIndustryHtmlNewsletterTemplate />
				</AdminPrivateRoute>
				<AdminPrivateRoute path={`${matchPath}/email/edit`} userSession={userSession}>
					<EditEmailTemplate />
				</AdminPrivateRoute>
				<AdminPrivateRoute path={`${matchPath}/social/edit`} userSession={userSession}>
					<EditSocialTemplate />
				</AdminPrivateRoute>
				<AdminPrivateRoute path={`${matchPath}/blog-post/edit/:id`} userSession={userSession}>
					<MediaChooserContext.Provider value={mediaContext}>
						<EditBlogPostTemplate />
					</MediaChooserContext.Provider>
				</AdminPrivateRoute>
				<AdminPrivateRoute path={`${matchPath}/hwc/create`} userSession={userSession}>
					<HwcCreateTemplate />
				</AdminPrivateRoute>
				<AdminPrivateRoute path={`${matchPath}/hwc/edit/:id`} userSession={userSession}>
					<HwcEditTemplate />
				</AdminPrivateRoute>
				<AdminPrivateRoute path={`${matchPath}/hwc/view/:id`} userSession={userSession}>
					<ViewHandwrittenCardTemplate />
				</AdminPrivateRoute>
			</Switch>
		</EditCampaignTemplateContext.Provider>
	);
});

EditCampaignTemplate.DisplayName = TitleDisplayName;
